import { render } from "./CustomerReport.vue?vue&type=template&id=e1b94618&scoped=true"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"

import "./CustomerReport.vue?vue&type=style&index=0&id=e1b94618&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b94618"],['__file',"src/views/h5/crm/report/CustomerReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1b94618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1b94618', __exports__)) {
    api.reload('e1b94618', __exports__)
  }
  
  module.hot.accept("./CustomerReport.vue?vue&type=template&id=e1b94618&scoped=true", () => {
    api.rerender('e1b94618', render)
  })

}


export default __exports__